import React from "react";
import { Route, Routes } from "react-router-dom";
import PersonalInfo from "../personalInfo";
import CentralWallet from "../centralWallet";
import BetOrderRecords from "../betOrderRecords";
import WalletExchange from "../walletExchange";
import InviteFriends from "../inviteFriends";
import TransferCenter from "../transferCenter";
import TransactionRecords from "../transactionRecords";
import AwardRecord from "../awardRecord";
import AccountManagement from "../accountManagement";
import MessageCenter from "../messageCenter";
import FeedBack from "../feedback";
import MyFeedback from "../myFeedback";


const MineChildRoute = () => {
    return <Routes>
        <Route path="personalInfo" element={<PersonalInfo />} />
        <Route path="centralWallet" element={<CentralWallet />} />
        <Route path="betOrderRecords" element={<BetOrderRecords />} />
        <Route path="walletExchange" element={<WalletExchange />} />
        <Route path="inviteFriends" element={<InviteFriends />} />
        <Route path="transferCenter" element={<TransferCenter />} />
        <Route path="transactionRecords" element={<TransactionRecords />} />
        <Route path="awardRecord" element={<AwardRecord />} />
        <Route path="accountManagement" element={<AccountManagement />} />
        <Route path="messageCenter" element={<MessageCenter />} />
        <Route path="feedback" element={<FeedBack />} />
        <Route path="myFeedback" element={<MyFeedback />} />
    </Routes>
}

export default MineChildRoute